import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Grid from '../grid/Grid';
import enhancer from '../enhancer';

class Regions extends React.Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.code}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Code']}
          rows={master.allRegions.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

const query = graphql`
  query RegionsAdminQuery {
    master {
      ...Regions_master
    }
  }
`;

export default enhancer(Regions, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Regions, {
        master: graphql`
          fragment Regions_master on Master {
            allRegions(first: 20) {
              edges {
                node {
                  id
                  name
                  code
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/Regions.js